import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { observer } from "mobx-react";
import { IconButton } from "@material-ui/core";

import { useStore } from "../../store";
import { Icon } from "../../components";
import { getWebBridge, setWebBridge } from "../../utils/webBridge";
import FeedsCategory from "./FeedsCategory";
import { firebaseEvent } from "../../utils/firebaseEvent";

const FeedsHeader = () => {
  const history = useHistory();
  const { id: categoryId } = useParams<{ id: string }>();
  const {
    appStore: { apiHeaderState },
    feedStore: {
      categoryState: { list, selectedId },
      onGetCategoryList,
      onSelectedCategory,
      onUpdateFeedList,
    },
  } = useStore();

  const onWebClose = () => {
    setWebBridge({
      name: "onWebClose",
    });
  };

  // mount 시 category update
  useEffect(() => {
    getWebBridge({ name: "onBackPress", callBack: onWebClose });

    if (list.length > 0) return;
    onGetCategoryList(apiHeaderState);

    if (categoryId) {
      onSelectedCategory(apiHeaderState, categoryId);
      history.replace(`/feeds/${categoryId}`);
    } else {
      onUpdateFeedList(apiHeaderState, 1);
    }
    // eslint-disable-next-line
  }, []);

  const isActive = (id?: string) => id === selectedId;
  const buttonTheme = (id?: string) => (isActive(id) ? "active" : "");

  // category 변경 시 list 초기화 및 req 변경
  const onClickCategory = (id?: string) => {
    if (isActive(id)) return;
    //Firebase Event
    const jsonParams = {
      P1: id,
    };
    firebaseEvent("select_category", jsonParams);
    onSelectedCategory(apiHeaderState, id);
  };
  const onFakeEvent = () => {
    if (window.location.pathname !== "/search") {
      onFakeEvent();
    } else {
      if (document.querySelector("input") == null) {
        setTimeout(() => {
          document.querySelector("input")?.focus();
        }, 100);
      }
    }
  };
  const SearchButton = () => {
    const onClick = () => {
      history.push("/search");
      onFakeEvent();

      // setTimeout(() => {}, 500);
    };
    return (
      <IconButton onClick={onClick}>
        <Icon name="search" size={28} />
      </IconButton>
    );
  };

  if (list.length === 0) return null;

  return (
    <React.Fragment>
      <FeedsCategory
        list={list}
        buttonTheme={buttonTheme}
        onClickCategory={onClickCategory}
      />
      <SearchButton />
    </React.Fragment>
  );
};

export default observer(FeedsHeader);
